import { getBillingClient } from '~/stores'

export async function getNewBillingReadonly(workspaceId: string): Promise<boolean> {
  const result = await getBillingClient(workspaceId).getBillingReadonly({})
  return result.planReadonly || result.addonsReadonly
}
